package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.frontend.common.views.collections.CollectionNavigatorMenuOption
import horcrux.frontend.common.views.collections.CollectionNavigatorState
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import react.FC
import react.Props

external interface CollectionDetailsDialogProps : Props {
    var currentCollectionMetadata: CollectionMetadata
    var collectionNavigatorState: CollectionNavigatorState
}

val CollectionMetadata.displayString: String
    get() = """Collection ID: ${this.id.betterToString()}
        
       Collection Name: ${this.collectionName.betterToString()}
        
       Created At: ${this.createdAt.toLocalDateTime(TimeZone.UTC)}
       
       Privacy Type: ${this.collectionPrivacyType.name}
       
       Embedding Model ID: ${this.embeddingModelID.modelID}
    """.trimIndent()

val CollectionDetailsDialog = FC<CollectionDetailsDialogProps> { props ->
    MetadataDetailsDialog {
        this.title = CollectionNavigatorMenuOption.COLLECTION_DETAILS.viewName
        this.detailsText = props.currentCollectionMetadata.displayString
        this.showDialogState = props.collectionNavigatorState.showCollectionDetailsDialogState
    }
}
